export const FileUploadIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 160 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M64.467 22.757A13.559 13.559 0 0 1 67.1 22.5h2.729v3H67.1c-.703 0-1.389.069-2.05.2l-.583-2.943Zm10.819-.257h5.457v3h-5.457v-3Zm10.914 0h5.457v3H86.2v-3Zm10.914 0h5.457v3h-5.457v-3Zm10.914 0h5.457v3h-5.457v-3Zm10.914 0h2.728c.9 0 1.78.088 2.633.257l-.582 2.943a10.56 10.56 0 0 0-2.051-.2h-2.728v-3Zm10.23 2.275a13.555 13.555 0 0 1 3.723 3.723l-2.493 1.67a10.56 10.56 0 0 0-2.899-2.9l1.669-2.493Zm-73.297 3.723a13.565 13.565 0 0 1 3.723-3.723l1.67 2.493a10.565 10.565 0 0 0-2.9 2.9l-2.493-1.67ZM53.6 36c0-.9.088-1.78.257-2.633l2.943.582c-.131.662-.2 1.348-.2 2.051v2.833h-3V36Zm81.313-2.633c.169.853.257 1.733.257 2.633v2.833h-3V36c0-.703-.069-1.389-.2-2.05l2.943-.583Zm.257 11.133v5.667h-3V44.5h3ZM53.6 50.167V44.5h3v5.667h-3Zm81.57 5.666V61.5h-3v-5.667h3ZM53.6 61.5v-5.667h3V61.5h-3Zm0 11.333v-5.666h3v5.666h-3Zm81.57-5.666v5.666h-3v-5.666h3Zm-81.57 17V78.5h3v5.667h-3Zm81.57-5.667v5.667h-3V78.5h3Zm-81.57 17v-5.667h3V95.5h-3Zm81.57-5.667V95.5h-3v-5.667h3Zm0 11.334V104c0 .9-.088 1.78-.257 2.633l-2.943-.582c.131-.662.2-1.348.2-2.051v-2.833h3ZM53.6 104v-2.833h3V104c0 .703.069 1.389.2 2.051l-2.943.582A13.558 13.558 0 0 1 53.6 104Zm5.998 11.225a13.569 13.569 0 0 1-3.723-3.723l2.493-1.669a10.56 10.56 0 0 0 2.9 2.899l-1.67 2.493Zm73.297-3.723a13.56 13.56 0 0 1-3.723 3.723l-1.669-2.493a10.554 10.554 0 0 0 2.899-2.899l2.493 1.669ZM67.1 117.5c-.9 0-1.78-.088-2.633-.257l.582-2.943c.662.131 1.348.2 2.051.2h2.729v3H67.1Zm57.203-.257c-.853.169-1.733.257-2.633.257h-2.728v-3h2.728c.703 0 1.389-.069 2.051-.2l.582 2.943Zm-43.56.257h-5.457v-3h5.457v3Zm10.914 0H86.2v-3h5.457v3Zm10.914 0h-5.457v-3h5.457v3Zm10.914 0h-5.457v-3h5.457v3Z"
      fill="#F8B1DC"
    />
    <path
      d="M94.57 48H40c-6.627 0-12 5.373-12 12v68c0 6.627 5.373 12 12 12h54.57c6.627 0 12-5.373 12-12V60c0-6.627-5.373-12-12-12Z"
      fill="#FCD9EF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M71.67 79.63a2 2 0 0 1 2-2h19.82a2 2 0 1 1 0 4H73.67a2 2 0 0 1-2-2ZM71.67 67.63a2 2 0 0 1 2-2h19.82a2 2 0 1 1 0 4H73.67a2 2 0 0 1-2-2ZM39.08 112a2 2 0 0 1 2-2h52.41a2 2 0 1 1 0 4H41.08a2 2 0 0 1-2-2ZM39.08 100a2 2 0 0 1 2-2h52.41a2 2 0 0 1 0 4H41.08a2 2 0 0 1-2-2ZM42.26 124a2 2 0 0 1 2-2h46.05a2 2 0 1 1 0 4H44.26a2 2 0 0 1-2-2Z"
      fill="#F8B1DC"
    />
    <path
      d="M57.82 60.37H47.01a7.85 7.85 0 0 0-7.85 7.85v10.81a7.85 7.85 0 0 0 7.85 7.85h10.81a7.85 7.85 0 0 0 7.85-7.85V68.22a7.85 7.85 0 0 0-7.85-7.85Z"
      fill="#072462"
    />
    <path
      d="M44.78 82.8c0-4.21 3.42-7.63 7.63-7.63s7.63 3.42 7.63 7.63M56.23 69.44a3.809 3.809 0 1 1-7.618.002 3.809 3.809 0 0 1 7.618-.002Z"
      fill="white"
    />
    <path
      d="M105.02 130.23 92.14 98.17c-.58-1.45.86-2.89 2.31-2.31l32.06 12.88c1.18.47 1.49 2 .59 2.9l-19.18 19.18c-.9.9-2.43.59-2.9-.59Z"
      fill="#EE399E"
    />
    <path
      d="m108.887 119.8 7.177-7.177 15.465 15.464c.975.976.975 2.56 0 3.536l-3.649 3.649a2.503 2.503 0 0 1-3.536 0l-15.464-15.465.007-.007Z"
      fill="#EE399E"
    />
  </svg>
);
